<!-- 管理人天 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <!-- <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch" :isAloneShow="true">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
          <el-button icon="el-icon-upload2" @click="exportExcel()" v-permission="['bill:manager:export']">导出</el-button>
        </template>
      </dynamic-search> -->
      <dynamic-form
        labelWidth="80px"
        :formConfig="formConfigHead"
        v-model="form"
        :showBtn="false"
      >
      </dynamic-form>
      <div class="search-wrap">
        <el-button class="filter-button" icon="el-icon-search" v-waves type="primary" @click="search">查询</el-button>
        <el-button class="filter-button" icon="el-icon-refresh-left" v-waves @click="reset">重置</el-button>
        <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        <el-button icon="el-icon-upload2" @click="exportExcel()" v-permission="['bill:manager:export']">导出</el-button>
      </div>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #billState="{row}">
          <el-tag :type="calcStatus(row.billState).type" v-text="calcStatus(row.billState).text"/>
        </template>
        <template #toolbar="scope">
          <el-button
            type="text"
            icon="el-icon-view"
            style="color:#4084B7;"
            @click="look(scope.row)"
          />
          <template v-if="!scope.row.billState || [1, 4].includes(scope.row.billState) || isAdmin">
            <el-button
              type="text"
              size="mini"
              icon="el-icon-edit"
              @click="edit(scope.row)"
            ></el-button>
            <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0;">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row.id)">确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
          </template>
        </template>
      </edit-data-table>
      <my-form ref="myForm" />
    </el-card>
  </div>
</template>

<script>
import '@/components/EditDataTable'
// import DynamicSearch from '@/components/DynamicSearch'
import DataTableMixin from '@/mixins/DataTableMixin'
import initDict from '@/mixin/initDict'
import {tableSataus} from '@/views/bill/mixins/status'
import '@/components/dynamic-form'
import { deepClone } from '@/utils'
import myForm from './form'
import {del} from '@/api/bill/manager-day'
import { downloadExcel2 } from "@/api/bill/ProjectPlan";
import { parseTime } from "@/utils";
import {getContractList} from '@/api/bill/contract';

export default {
  name: 'ManagerDay',
  mixins: [DataTableMixin, initDict, tableSataus],
  components: {
    // DynamicSearch,
    myForm
  },
  provide() {
    return {
      parentThis: this
    }
  },
  data() {
    return {
      delLoading: false,
      form: {},
      tableHead: [
        {
          prop: 'matter',
          label: '管理事项'
        },
        {
          prop: 'type',
          label: '管理类型',
          query: {
            type: 'select',
            data: []
          },
          formatter: (val) => {
            if (!this.dictMap['manager_type']) {
              return ''
            }
            const op = this.dictMap['manager_type'].find(value => {
              return value.value === val
            })
            if (op) {
              return op.label
            }
            return ''
          }
        },
        {
          prop: 'manDayType',
          label: '项目号',
          query: {
            type: 'input'
          },
          // formatter: (val) => {
          //   if (!this.dictMap['manager_day_type']) {
          //     return ''
          //   }
          //   const op = this.dictMap['manager_day_type'].find(value => {
          //     return value.value === val
          //   })
          //   if (op) {
          //     return op.label
          //   }
          //   return ''
          // }
        },
        {
          prop: 'manDayTypeName',
          label: '项目名',
        },
        {
          prop: 'manDay',
          label: '事项人天',
        },
        {
          label: '事项时间',
          prop: 'matterTime',
          query: {
            type: "datetimerange",
            key: "matterTime"
          }
        },
        {
          prop: 'remark',
          label: '备注',
        },
        {
          prop: 'modified',
          label: '上报时间',
        },
        {
          prop: 'creatorName',
          label: '任务人',
          query: {
            type: 'input'
          }
        },
        /* {
          prop: 'billState',
          label: '单据状态',
          type: 'slot',
          align: 'center',
          width: 100,
          query: {
            type: 'select',
            data: [
              {
                label: '审批中',
                value: 2
              },
              {
                label: '已审批',
                value: 3
              },
              {
                label: '退回',
                value: 4
              }
            ]
          },
        } */
      ],
      formConfigHead: {
        formItemList: [
          {
            label: '管理类型',
            type: 'select',
            key: 'type',
            placeholder: "请选择",
            optionsUrl: '/dict-detail',
            span: 6,
            params: {
              code: 'manager_type'
            }
          },
          {
            type: "input",
            key: "manDayType",
            label: "项目号",
            placeholder: "请输入",
            span: 5
          },
          {
            label: '事项时间',
            type: 'date',
            subtype: 'datetimerange',
            key: 'matterTime',
            valueFormat: 'yyyy-MM-dd',
            placeholder: "请选择",
            span: 7
          },
          {
            label: "任务人",
            key: "creatorName",
            type: "databox",
            placeholder: "请选择人员",
            span: 6,
            props: {
              label: "name",
              value: "id"
            },
            url: "/user/list",
            tableColumn: [
              {
                property: "code",
                label: "编码",
                align: "center",
                query: {
                  type: "input"
                }
              },
              {
                property: "name",
                label: "名称",
                align: "center",
                query: {
                  type: "input"
                }
              }
            ],
            extendParms: { queryFieldItem: "id,number,name" },
            multiple: false
          },
          /* {
            label: '单据状态',
            type: 'select',
            key: 'billState',
            placeholder: "请选择",
            span: 6,
            options: [
              {
                label: '审批中',
                value: 2
              },
              {
                label: '已审批',
                value: 3
              },
              {
                label: '退回',
                value: 4
              }
            ]
          } */
        ]
      },
      // 合同
      contractList: [],
      idoProjectList: [],
      bzProjectList: []
    }
  },
  created() {
    // 任务分类
    this.getDict("manager_type").then(res => {
      this.$set(this.dictMap, 'manager_type', res.data || [])
      this.$set(this.tableHead[1].query, 'data', res.data)
    })
    // 虚拟合同
    getContractList({contractType: 2, billState: 3, category: 'M'}).then(res => {
      if (res.code === 200) {
        if (res.data && res.data.length) {
          this.contractList = res.data.map(i => {
            i.label = `${i.name} - (${i.businessId})`
            i.value = i.businessId
            return i;
          })
        }
      }
    })
    // 列表数据初始化
    this.$nextTick(() => {
      this.dataTableInit()
    })
  },
  methods: {
    // 搜索
    search() {
      this.dataTableInit()
    },
    // 重置
    reset() {
      this.form = {}
      this.dataTableInit()
    },
    formatter (val) {
      if (val) {
        const date = new Date(val);
        return parseTime(date, "{y}-{m}-{d}");
      }
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/managerDay/listPage`
      const params = {
        size: this.offset,
        page: this.page
      }
      /* if (this._query.matterTime) {
        this._query.startTime = this.formatter(this._query.matterTime[0])
        this._query.endTime = this.formatter(this._query.matterTime[1])
        delete this._query.matterTime
      } */
      this._params = Object.assign(params, this._query)
      console.log(this.form)
      if (this.form.type) { this._params.type = this.form.type }
      if (this.form.manDayType) { this._params.manDayType = this.form.manDayType }
      if (this.form.matterTime) {
        this._params.startTime = this.formatter(this.form.matterTime[0])
        this._params.endTime = this.formatter(this.form.matterTime[1])
      }
      if (this.form.creatorName) { this._params.chooseCreator = this.form.creatorName.id }
      if (this.form.billState) { this._params.billState = this.form.billState }
      return true
    },
    // 删除
    del(id) {
      this.delLoading = true
      del(id)
        .then(() => {
          this.$notify({ title: '删除成功！', type: 'success', duration: 2500 })
          this.dleTableChangePage()
          this.dataTableInit()
          this.delLoading = false
        })
        .catch(() => {
          this.delLoading = false
        })
    },
    // 打开添加弹框
    add() {
      this.$refs.myForm.openLook = false
      this.$refs.myForm.dialogVisible = true
    },
    // 修改
    edit(row) {
      const data = deepClone(row)
      this.$refs.myForm.openLook = false
      this.$refs.myForm.form = data
      this.$refs.myForm.dialogVisible = true
    },
    look(row) {
      const data = deepClone(row)
      this.$refs.myForm.openLook = true
      this.$refs.myForm.form = data
      this.$refs.myForm.dialogVisible = true
    },
    calcStatus(state) {
      if (!state || state === 1) {
        return {
          type: 'info',
          text: '草稿'
        }
      }
      if (!state || state === 4) {
        return {
          type: 'info',
          text: '退回'
        }
      }
      if (state === 2) {
        return {
          type: 'warning',
          text: '审批中'
        }
      }
      if (state === 3) {
        return {
          type: 'success',
          text: '已审批'
        }
      }
    },
    exportExcel() {
      /* if (this._query.matterTime) {
        this._query.startTime = this.formatter(this._query.matterTime[0])
        this._query.endTime = this.formatter(this._query.matterTime[1])
        delete this._query.matterTime
      } */
      this._params = Object.assign({}, this._query)
      console.log(this.form)
      if (this.form.type) { this._params.type = this.form.type }
      if (this.form.manDayType) { this._params.manDayType = this.form.manDayType }
      if (this.form.matterTime) {
        this._params.startTime = this.formatter(this.form.matterTime[0])
        this._params.endTime = this.formatter(this.form.matterTime[1])
      }
      if (this.form.creatorName) { this._params.chooseCreator = this.form.creatorName.id }
      if (this.form.billState) { this._params.billState = this.form.billState }
      downloadExcel2('/managerDay/export',this._params,'管理人天.xlsx')
    }
  }
}
</script>

<style scoped>
  .btn {
    border: none;
    padding: 0;
  }
  .search-wrap {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 10px;
  }
  .dynamic-form {
    padding: 0;
  }
</style>
